var map = {
	"./network-logos/aptos-disable.svg": 78629,
	"./network-logos/aptos.svg": 24952,
	"./network-logos/arbitrum-disable.svg": 68858,
	"./network-logos/arbitrum.svg": 1064,
	"./network-logos/avax-disable.svg": 16002,
	"./network-logos/avax.svg": 88655,
	"./network-logos/bsc-disable.svg": 20767,
	"./network-logos/bsc.svg": 3304,
	"./network-logos/cronos-disable.svg": 56080,
	"./network-logos/cronos.svg": 56146,
	"./network-logos/ethereum-disable.svg": 67799,
	"./network-logos/ethereum.svg": 86906,
	"./network-logos/fantom-disable.svg": 5928,
	"./network-logos/fantom.svg": 71908,
	"./network-logos/optimism-disable.svg": 98834,
	"./network-logos/optimism.svg": 37951,
	"./network-logos/phantom.svg": 57527,
	"./network-logos/polygon-disable.svg": 91976,
	"./network-logos/polygon.svg": 44125,
	"./network-logos/solana-disable.svg": 92812,
	"./network-logos/solana.svg": 80792,
	"./network-logos/sui-disable.png": 62825,
	"./network-logos/sui.png": 58273,
	"./network-logos/tc.jpeg": 25665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2604;